import React from 'react'
import LeftmenuIn from '../Components/LeftmenuIn'
import DashnavIn from '../Components/DashnavIn'
import ClientsComp from './ClientsComp'


function Clientprojects() {
  return (
    <div className='mainContainer'>
        <LeftmenuIn/>
        <div className='theMainContainer'>
        <DashnavIn/>
        <ClientsComp/>
        
        </div>
    </div> 
  )
}

export default Clientprojects